export const AdvancedOptionType = {
    DO_NOT_ALLOW_SKIP: 'DoNotAllowSkip',
} as const;

export type AdvancedOptionTypeValue = (typeof AdvancedOptionType)[keyof typeof AdvancedOptionType];
